export const validate = (values) => {
  const errors = {}

  return errors
}
